export const SMSVerificationConstants = {
    SEND_REQUEST: 'SMS_VERIFICATION_SEND_REQUEST',
    SEND_SUCCESS: 'SMS_VERIFICATION_SEND_SUCCESS',
    SEND_FAILURE: 'SMS_VERIFICATION_SEND_FAILURE',
    RESET_SUCCESS: 'SMS_VERIFICATION_RESET_SUCCESS',
};